import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { Container, Typography, withStyles } from '@material-ui/core';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import { contentPageMaxWidth } from '../../../../constants';

const styles = theme => ({
  root: {
    display: 'block',
  },
  title: {
    margin: theme.spacing(12, 0, 2),
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(15, 0, 3),
    },
  },
});

function Title({ classes, className, maxWidth, pageData }) {
  const inspectorProps = useContentfulInspectorMode();

  let title = get(pageData, 'title');

  if (isEmpty(title)) {
    title = get(pageData, 'name');
  }

  if (isEmpty(title)) {
    return null;
  }

  return (
    <Container maxWidth={maxWidth !== '' ? maxWidth : contentPageMaxWidth} className={clsx(classes.root, className)}>
      <Typography
        variant="h1"
        className={classes.title}
        {...inspectorProps({
          entryId: get(pageData, 'contentful_id'),
          fieldId: 'title',
        })}>
        {title}
      </Typography>
    </Container>
  );
}

Title.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  maxWidth: PropTypes.oneOf(['', false, 'xs', 'sm', 'md', 'lg', 'xl']),
  pageData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

Title.defaultProps = {
  classes: {},
  className: null,
  maxWidth: '',
  pageData: null,
};

export default withStyles(styles)(Title);
